import gql from 'graphql-tag';

export const UserFragment = gql`
	fragment UserFragment on ExternalUserType {
		contentType
		displayName
		imageUrl
		psId
		... on ProfileType {
			smallAvatarUrl
			firstName
			lastName
		}
		... on OrganizationTeamType {
			name
			smallLogoUrl
		}
	}
`;
